module.exports = __webpack_public_path__ + "img/notification.b0cf4a95.svg";